import React from "react";
import "./loading.scss";

export default function Loading() {
  return <div id="spinner"></div>;
}
